export default class EntityFactory {
    // #region Vars
    _Host;
    _definitions = [];
    // #endregion
    // #region Constructor
    constructor(host) {
        // #region Vars
        this._Host = host;
        // #endregion        
    }
    // #endregion
    // #region Boostrap
    initialize(entities) {
        if (entities) {
            entities.forEach(e => this._definitions.push(e));
        }
    }
    // #endregion
    // #region Core
    rescolveComponent(entity) {
        // #region Vars
        let tEntity = entity.root;
        let tAddress = "";
        let tDef = null;
        // #endregion
        // #region Init
        if (entity.segments.length > 1) {
            tAddress = [...entity.segments].splice(1).join('/');
        }
        // #endregion
        // #region Find
        this._definitions.forEach(d => {
            if (tDef) {
                return;
            }
            if (d.mode !== entity.mode) {
                return;
            }
            if (d.name !== tEntity) {
                return;
            }
            if (d.address) {
                if (d.address !== tAddress) {
                    return;
                }
            }
            tDef = d;
            {
                return;
            }
        });
        // #endregion
        // #region Props
        let tProp = {};
        if (tDef?.componentProps) {
            Object.keys(tDef.componentProps).forEach((k) => {
                if (k.endsWith('@comp.exp')) {
                    let tName = k.split('@')[0];
                    let tExp = tDef.componentProps[k];
                    let tValue = null;
                    try {
                        tValue = utils.evalExpression({ entity: entity }, tExp);
                    }
                    catch {
                        //DO nothing
                    }
                    tProp[tName] = tValue;
                }
                else {
                    tProp[k] = tDef.componentProps[k];
                }
            });
        }
        // #endregion
        return {
            component: {
                component: tDef?.componentName,
                componentProps: tProp,
            },
            meta: tDef?.meta
        };
    }
}
